
    var riot = require('riot')
    
riot.tag2('counter', '<h2>{Math.round(total)}{opts.suffix}</h2> <h3>{opts.subtitle}</h3>', 'counter, [riot-tag="counter"] { min-height: calc(7vw + 80px); display: block; text-align: center; } counter h2, [riot-tag="counter"] h2 { font-size: calc(5vw + 20px); color: rgba(38,79,99,0.5); text-align: center; } counter h3, [riot-tag="counter"] h3 { font-size: calc(1vw + 10px); color: #264f63; }', '', function(opts) {
this.on('mount', function() {
  this.total = 0;
  return this.interval = setInterval((function(_this) {
    return function() {
      return requestAnimationFrame(_this.update);
    };
  })(this), 20);
});

this.on('update', function() {
  var inc;
  inc = opts.total / 150;
  if (this.total < opts.total) {
    return this.total += inc;
  } else if (this.interval) {
    clearInterval(this.interval);
    return this.interval = null;
  }
});
});
    
  